import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { authenticateDriver } from "../../actions/commonActions";
import Spinner from "../UI/Spinner/spinner";
import "./Login.css";
import { logout } from "../../utils/helper";
import setAxiosHeader from "../../utils/setAxiosHeader";
import Logo from "../../Logo.png";

function Login() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [authFailed, setAuthFailed] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const {
    token,
    loading,
    id,
    userAccount,
    loginError,
    evChargingSites,
    tag_id,

  } = useSelector((reduxState) => reduxState.driverProfile);

  //if user gets authenticated store token
  useEffect(() => {
    if (token) {
      const first_name = userAccount.person.first_name || "";
      const last_name = userAccount.person.last_name || "";
      localStorage.setItem("driverToken", token);
      localStorage.setItem("driver_id", id);
      localStorage.setItem("first_name", first_name);
      localStorage.setItem("last_name", last_name);
      localStorage.setItem("tag_id", tag_id);
      localStorage.setItem("ev_charging_site_id", evChargingSites.ev_charging_site_id);

      // *********************  Mobile app stuff ***********************

      // For Android
      if (window.androidObj == undefined) {
        window.androidObj = function AndroidClass() { };
      }

      if (window.androidObj.setToken !== undefined) {
        window.androidObj.setToken(token, id, first_name + " " + last_name);
      }

      if (window.androidObj.profileCompleted !== undefined) {
        window.androidObj.profileCompleted(true);
      }

      if (window.androidObj.logoutUser !== undefined) {
        window.androidObj.logoutUser(logout);
      }
      // end android

      // For IOS
      if (window.webkit) {
        window.webkit.messageHandlers.setToken.postMessage({
          token: token,
          profile_id: `${id}`,
        });

        //  Following will trigger profile complete and return control to native app
        window.webkit.messageHandlers.profile.postMessage({
          completed: true,
        });
        // ===========

        window.webkit.messageHandlers.logoutUser.postMessage({
          logout: () => {
            localStorage.removeItem("driverToken");
            localStorage.removeItem("driver_id");
            localStorage.removeItem("first_name");
            localStorage.removeItem("last_name");
            localStorage.removeItem(
              "ev_charging_site_id",
              evChargingSites.ev_charging_site_id
            );
          },
        });
      }
      // End IOS
      // *********************  Mobile app stuff ***********************
      setAxiosHeader(token);
      history.push(`/home`);
    }
  }, [token]);

  useEffect(() => {
    if (loginError) {
      setAuthFailed(true);
    } else {
      setAuthFailed(false);
    }
  }, [loginError]);

  const formOnSubmit = (e) => {
    e.preventDefault();
    const payload = {
      userName: userName,
      password: password,
    };

    authenticateDriver(dispatch, payload);
  };

  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
  };

  const userNameChangeHamdler = (e) => {
    setUserName(e.target.value);
  };

  return (
    <div className="parent-div text-center">
      <div>
        <div className="mb-5">
          <img className="" src={Logo} alt="" width="72" height="72" /> <br />
          <span>
            <b>eluTAG</b>
          </span>
          <p>connecting electric vehicle ecosystem</p>
        </div>
        <form className="form-signin" onSubmit={formOnSubmit}>
          <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
          {authFailed && (
            <div
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              Invalid Usename or password
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
          )}
          <label htmlFor="inputEmail" className="sr-only">
            Email address
          </label>
          <input
            type="text"
            id="inputEmail"
            className="form-control mb-2"
            placeholder="Email"
            value={userName}
            required=""
            onChange={userNameChangeHamdler}
            autoFocus=""
          />
          {/* <label htmlFor="inputPassword" className="sr-only">
          Password
        </label> */}
          <div style={{position:"relative"}}>
           
          <input
            type={showPassword ? "text" : "password"}
            id="inputPassword"
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={passwordChangeHandler}
            required=""
          />
           <i
              className="fa fa-eye float-right"
              style={{

                lineHeight: 2,
  fontSize: "25px",
  zIndex: 900,
  position: "absolute",
  top: "0",
  right: "12px"
              }}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            ></i>
                      </div>

          <div class="checkbox mb-3 text-right">
            <Link to={`/forgot_password`}>Forgot Password ?</Link>
          </div>
          {loading ? (
            <Spinner spinnerStyle={"spinner-border text-dark mt-3"} />
          ) : (
            <button
              className="btn btn-sm btn-primary btn-block mt-5 green-two-bg"
              type="submit"
            >
              Sign in
            </button>
          )}
          <Link
            to={`/register-profile`}
            className="btn btn-info blue-one-bg btn-block"
          >
            <i className="fa fa-user-plus"></i> Don't have an account? Sign up!
          </Link>
        </form>
      </div>
    </div>
  );
}

export default Login;
